import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC, PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';
import type { z } from 'zod';

import { CommentFormSchema } from '@/features/comment/models/comment';

type FormValues = z.infer<typeof CommentFormSchema>;
type InitialFormValues = Partial<FormValues>;

export const CommentFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const formMethods = useForm<InitialFormValues, FormValues>({
    defaultValues: {
      publishType: 'private',
      assigneeIds: [],
      relatedUserIds: [],
      sharedOrganizationIds: [],
      content: '',
    },
    resolver: zodResolver(CommentFormSchema),
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
